import React from "react";

import { filter, sortBy, startCase } from "lodash";

import Input from "../forms/Input";

export default class DataTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortDesc: false,
      sortField: null,
      displayFilter: false,
      filterText: "",
    };
  }

  sortData = () => {
    const { sortDesc, sortField } = this.state;
    let sortedData = sortBy(this.props.data, [sortField]);
    if (sortDesc) sortedData = sortedData.reverse();
    return sortedData;
  };

  selectFieldToSort = (fieldName) => {
    const availableFields = Object.keys(this.props.data[0]);

    if (availableFields.includes("_" + fieldName)) {
      fieldName = "_" + fieldName;
    }

    if (this.state.sortField === fieldName) {
      this.setState({ sortDesc: !this.state.sortDesc });
    } else {
      this.setState({ sortField: fieldName });
    }
  };

  toggleFilterInput = () => {
    this.setState({
      ...this.state,
      displayFilter: !this.state.displayFilter,
    });
  };

  handleFilterTextChange = (val) => {
    this.setState({
      ...this.state,
      filterText: val.trim().toLowerCase(),
    });
  };

  //when the filter text updates
  //update the dataset
  //dispatch to the store and filter the data there
  filterData = (data) => {
    const predicate = (o) => {
      //for object keys
      //if k[0] is underscore move in
      //ignore numbers
      for (const k in o) {
        const v = o[k];

        if (typeof v === "Number") continue;

        const coercedValue = String(v);

        if (coercedValue.trim().toLowerCase().includes(this.state.filterText)) {
          return true;
        }
      }
      return false;
    };

    //check for the presence of this.state.filterText in various fields
    //go through unknown objects and check for presence in values
    let res;
    if (this.state.filterText === "") {
      res = data;
    } else {
      res = filter(data, predicate);
    }

    if (this.props.rowsToDisplay) return res.slice(0, this.props.rowsToDisplay);
    return res;
  };

  buildColumnKeys() {
    return Object.keys(this.props.data[0])
      .filter((d) => d !== "id")
      .filter((d) => d.charAt(0) !== "_");
  }

  buildHeaders = () => {
    //
    if (!this.props.data.length) return;

    let keys = this.buildColumnKeys();

    if (this.props.actions) {
      keys = [...this.props.actions.map((d) => d.title), ...keys];
    }

    return keys.map((d, i) => (
      <th
        onClick={() => this.selectFieldToSort(d)}
        key={`head${d}-${i}`}
        className={"clickable"}
      >
        {d === "✂" ? <i className="fa fa-cut ml-2" /> : startCase(d)}
        {[d, "_" + d].includes(this.state.sortField)
          ? this.state.sortDesc
            ? "▽"
            : "△"
          : ""}
      </th>
    ));
  };

  buildRows = () => {
    if (!this.props.data.length) return <tr></tr>;

    const sortedData = this.sortData();
    const displayData = this.filterData(sortedData);
    const keys = this.buildColumnKeys();

    return displayData.map((d) => {
      let cells = keys.map((v, i) => <td key={`cell${v}-${i}`}>{d[v]}</td>);

      if (this.props.actions) {
        cells = [
          ...this.props.actions.map((a) => (
            <td>
              <i
                className={`fas ${a.icon} table-icon clickable`}
                onClick={() => a.action(d._data)}
              />
            </td>
          )),
          ...cells,
        ];
      }

      if (this.props.events_modal) {
        return (
          <tr
            onClick={() => this.props.events_modal(d)}
            className={"clickable"}
            style={d._rowStyle ? { ...d._rowStyle } : {}}
          >
            {cells}
          </tr>
        );
      }
      return <tr style={d._rowStyle ? { ...d._rowStyle } : {}}>{cells}</tr>;
    });
  };

  buildFooter = () => {
    if (!this.props.data.length) return <tr></tr>;

    const displayData = this.filterData(this.props.data);

    if (displayData.length < 2) return <tr></tr>;

    const keys = this.buildColumnKeys();

    const sums = {};
    displayData.forEach((d) => {
      keys.forEach((k) => {
        if (typeof d[k] === "number") {
          if (typeof sums[k] !== "number") sums[k] = 0;
          sums[k] += d[k];
        }
      });
    });

    const cells = keys.map((k, i) =>
      typeof sums[k] === "undefined" ? (
        <td></td>
      ) : (
        <td key={`foot${k}-${i}`}>{sums[k]}</td>
      )
    );

    return <tr>{cells}</tr>;
  };

  // ▽ // △

  render() {
    return (
      <div>
        <div className="info-panel">
          <div className="info-panel-heading">
            {this.props.title}
            {!this.props.noFilter && (
              <>
                <i
                  style={{ float: "right", marginTop: "7px" }}
                  onClick={this.toggleFilterInput}
                  className="fa fa-filter"
                  aria-hidden="true"
                />
                <span
                  style={{
                    float: "right",
                    margin: "0 15px 0 0",
                    fontSize: "10px",
                  }}
                >
                  {this.filterData(this.props.data).length} of{" "}
                  {this.props.data.length} rows
                </span>
              </>
            )}
          </div>
          {!this.state.displayFilter && !this.props.displayFilter ? null : (
            <Input
              type={"text"}
              default={this.state.filterText}
              onChange={this.handleFilterTextChange}
              placeholder={this.props.filterText || "Filter..."}
            />
          )}
          {!!this.props.customSubHeader && <>{this.props.customSubHeader}</>}
          <div className="content">
            <table className="tbl-med">
              <thead>
                <tr>{this.buildHeaders()}</tr>
              </thead>
              <tbody>{this.buildRows()}</tbody>
              {this.props.showFooter === true && (
                <tfoot>{this.buildFooter()}</tfoot>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  }
}
